<div class="kendo-formfield">
  <kendo-label *ngIf="label" [text]="label"></kendo-label>
  <div class=" left-search-icon">
    <div style="position: relative;">
      <i class="fa fa-search" aria-hidden="true" style="position: absolute; left: 10px; top: 20px; z-index: 1;"></i>
      <kendo-textbox #addresstext [value]="searchString" (valueChange)="onSearchChange($event)" (blur)="onTouch()"
        [placeholder]="placeholder" fillMode="outline" [clearButton]="true" style="padding-left: 30px;">
      </kendo-textbox>
    </div>
  </div>
</div>
